import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { JobWorkService, Combo2Service } from "../../../services/index";
import { PrintData } from "../../master/print/print";
declare var google;

@Component({
  selector: "actual-cutting-receipt",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./JobactualCutting.html",
})
export class JobActualCuttingComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  total_mtrs: number = 0;
  total_qty: number = 0;
  total_wo: number = 0;
  seasonList = [];
  gridOptions: any;
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  printData;
  statusList = ["AC COMPLETE", "AC INCOMPLETE"];
  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  filter = {
    unit: "",
    wo_no: "",
    cp_date: "",
    cu_no: "",
    groupby: "cu_no",
    status: "AC INCOMPLETE",
    ff_cp_no: "",
    ff_date: "",
  };
  page = {
    limit: 100,
    count: 0,
    offset: 0,
    orderBy: "cu_no",
    orderDir: "desc",
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("orderTemplate") orderTemplate: TemplateRef<any>;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    private acService: JobWorkService,
    private modalService: BsModalService,
    public toasterService: ToasterService
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    if (
      this.filter.groupby == "cu_no" &&
      this.filter.status == "AC INCOMPLETE"
    ) {
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "CU No",
          prop: "cu_no",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "CU.Date",
          prop: "cp_date",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
        },
        {
          name: "CP No",
          prop: "ff_cp_no",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "FF.Date",
          prop: "ff_date",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
        },

        {
          name: "CU ratio",
          prop: "cutting_ratio",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 90,
          maxWidth: 90,
          width: 90,
        },
        {
          name: "No.of.Wo(s)",
          prop: "no_of_wo",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 85,
          maxWidth: 85,
          width: 85,
        },
        {
          name: "No.of.Pcs",
          prop: "tot_lumps",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Width",
          prop: "width",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        // {
        //   name: "Fab.Style",
        //   prop: "fab_style",
        //   headerClass: "text-center",
        //   cellClass: "text-center",
        //   minWidth: 120,
        //   maxWidth: 120,
        //   width: 120,
        // },
        // {
        //   name: "Fab.type",
        //   prop: "fab_type",
        //   headerClass: "text-center",
        //   cellClass: "text-center",
        //   minWidth: 80,
        //   maxWidth: 80,
        //   width: 80,
        // },
        {
          name: "Shirt.style",
          prop: "style",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Tot.Mtrs",
          prop: "tot_mtrs_qty",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Tot.Qty",
          prop: "tot_pcs_qty",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Brand",
          prop: "brand",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Action",
          prop: "sno",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
          sortable: false,
          cellTemplate: this.editDeleteTemplate,
        },
      ];
    } else if (
      this.filter.groupby == "wo_no" &&
      this.filter.status == "AC INCOMPLETE"
    ) {
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "Wo.no",
          prop: "wo_no",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Wo.Date",
          prop: "work_date",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
        },
        {
          name: "Dc.no",
          prop: "dc_no",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Fab Design",
          prop: "fab_design",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        // {
        //   name: "Shirt Design",
        //   prop: "shirt_design_no",
        //   headerClass: "text-center",
        //   cellClass: "text-center",
        //   minWidth: 120,
        //   maxWidth: 120,
        //   width: 120,
        // },
        {
          name: "Cutting ratio",
          prop: "cutting_ratio",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 90,
          maxWidth: 90,
          width: 90,
        },
        {
          name: "No.of.Colors",
          prop: "no_of_colors",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 83,
          maxWidth: 83,
          width: 83,
        },
        {
          name: "No.of.Pcs",
          prop: "tot_lumps",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Width",
          prop: "width",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        // {
        //   name: "Fab.Style",
        //   prop: "fab_style",
        //   headerClass: "text-center",
        //   cellClass: "text-center",
        //   minWidth: 120,
        //   maxWidth: 120,
        //   width: 120,
        // },
        // {
        //   name: "Fab.type",
        //   prop: "fab_type",
        //   headerClass: "text-center",
        //   cellClass: "text-center",
        //   minWidth: 80,
        //   maxWidth: 80,
        //   width: 80,
        // },
        {
          name: "Shirt.style",
          prop: "style",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Tot.Mtrs",
          prop: "tot_mtrs_qty",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Tot.Qty",
          prop: "tot_pcs",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Brand",
          prop: "brand",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Appr.Status",
          prop: "approvedStatus",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Action",
          prop: "sno",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
          sortable: false,
          cellTemplate: this.editDeleteTemplate,
        },
      ];
    }
    if (this.filter.groupby == "cu_no" && this.filter.status == "AC COMPLETE") {
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "CU No",
          prop: "cu_no",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "CU Date",
          prop: "cp_date",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
        },
        {
          name: "C.P No",
          prop: "ff_cp_no",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "FF.Date",
          prop: "ff_date",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
        },

        {
          name: "CU ratio",
          prop: "cutting_ratio",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 90,
          maxWidth: 90,
          width: 90,
        },
        {
          name: "No.of.Wo(s)",
          prop: "no_of_wo",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 85,
          maxWidth: 85,
          width: 85,
        },
        {
          name: "No.of.Pcs",
          prop: "tot_lumps",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Width",
          prop: "width",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        // {
        //   name: "Fab.Style",
        //   prop: "fab_style",
        //   headerClass: "text-center",
        //   cellClass: "text-center",
        //   minWidth: 120,
        //   maxWidth: 120,
        //   width: 120,
        // },
        // {
        //   name: "Fab.type",
        //   prop: "fab_type",
        //   headerClass: "text-center",
        //   cellClass: "text-center",
        //   minWidth: 80,
        //   maxWidth: 80,
        //   width: 80,
        // },
        {
          name: "Shirt.style",
          prop: "style",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Tot.Mtrs",
          prop: "tot_mtrs_qty",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Tot.Qty",
          prop: "tot_pcs_qty",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Brand",
          prop: "brand",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Action",
          prop: "sno",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
          sortable: false,
          cellTemplate: this.editDeleteTemplate,
        },
      ];
    } else if (
      this.filter.groupby == "wo_no" &&
      this.filter.status == "AC COMPLETE"
    ) {
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "Ac.Ref No",
          prop: "ac_ref_no",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 85,
          maxWidth: 85,
          width: 85,
        },
        {
          name: "Wo.Ref No",
          prop: "wo_ref_no",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 88,
          maxWidth: 88,
          width: 88,
        },
        {
          name: "Cu.No",
          prop: "cu_no",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "CP.Date",
          prop: "cp_date",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
        },
        {
          name: "C.P No",
          prop: "ff_cp_no",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "FF.Date",
          prop: "ff_date",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
        },
        {
          name: "WO.Date",
          prop: "fdate",
          headerClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        // {
        //   name: "CU No",
        //   prop: "cu_no",
        //   cellClass: "text-center",
        //   headerClass: "text-center",
        //   minWidth: 100,
        //   maxWidth: 100,
        //   width: 100,
        // },
        {
          name: "WO No",
          prop: "wo_no",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Unit",
          prop: "unit",
          headerClass: "text-center",
          minWidth: 130,
          maxWidth: 130,
          width: 130,
        },
        // {
        //   name: "Shirt Design",
        //   prop: "shirt_design_no",
        //   headerClass: "text-center",
        //   cellClass: "text-center",
        //   minWidth: 120,
        //   maxWidth: 120,
        //   width: 120,
        // },
        {
          name: "Action",
          prop: "sno",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
          sortable: false,
          cellTemplate: this.editDeleteTemplate,
        },
        {
          name: "Details",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          sortable: false,
          cellTemplate: this.orderTemplate,
        },
      ];
    }

    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#unit").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getOrderList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getColumns();
  }

  clearFilter(): void {
    this.filter.unit = "";
    this.filter.cu_no = "";
    this.filter.cp_date = "";
    this.filter.wo_no = "";
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getColumns();
  }

  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function (res) {
      //  this.LoadAgentList();
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }
  bsModalRef: BsModalRef;
  // printCutting(row) {
  //   let params = row;
  //   this.acService.printCutting(params).then((res: any) => {
  //     debugger;
  //     this.printData = res;

  //     this.bsModalRef = this.modalService.show(PrintData, {
  //       keyboard: false,
  //       ignoreBackdropClick: true,
  //       class: "compWidth-80",
  //     });
  //     this.bsModalRef.content.stkdata = Object.assign({}, row);
  //     this.bsModalRef.content.printcontent = this.printData;
  //   });
  // }
  addEditPO(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getOrderList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD JOBACTUAL CUTTING",
          title: "ADD JOBACTUAL CUTTING",
          tabParent: "JOBWORK ORDER",
          mode: mode,
          data: row,
          name: "ADD JOBACTUAL CUTTING",
        },
      };
    } else if (mode == "Edit") {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "EDIT CUTTING DETAILS",
          title: "EDIT CUTTING DETAILS",
          tabParent: "PURCHASE",
          mode: mode,
          data: row,
          name: "EDIT CUTTING DETAILS",
        },
      };
    } else {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "VIEW JOBACTUAL CUTTING",
          title: "VIEW JOBACTUAL CUTTING",
          tabParent: "PURCHASE",
          mode: mode,
          data: row,
          name: "VIEW JOBACTUAL CUTTING",
        },
      };
    }

    this.tabUpdateEvent.emit(tabObj);
  }
  viewFabFacStoreWo(row) {
    this.filter.ff_cp_no = row.ff_cp_no;
    this.filter.ff_date = row.ff_date;
    this.filter.groupby = "wo_no";
    this.getColumns();
  }
  gobacktoCpGroup() {
    this.filter.ff_cp_no = "";
    this.filter.ff_date = "";
    this.filter.groupby = "cu_no";
    this.getColumns();
  }
  getOrderList(): void {
    if (this.filter.cp_date == "") {
      this.filter.cp_date = "";
    } else {
      this.filter.cp_date = this.datePipe.transform(
        this.filter.cp_date,
        "yyyy-MM-dd"
      );
    }
    if (this.filter.ff_date == "") {
      this.filter.ff_date = "";
    } else {
      let ffdate = this.filter.ff_date.split("-");
      if (ffdate[2].split("").length == 4) {
        this.filter.ff_date = ffdate[2] + "-" + ffdate[1] + "-" + ffdate[0];
      } else {
        this.filter.ff_date = this.datePipe.transform(
          this.filter.ff_date,
          "yyyy-MM-dd"
        );
      }
    }

    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      unit: this.filter.unit,
      cu_no: this.filter.cu_no,
      wo_no: this.filter.wo_no,
      cp_date: this.filter.cp_date,
      groupby: this.filter.groupby,
      status: this.filter.status,
      ff_date: this.filter.ff_date,
      ff_cp_no: this.filter.ff_cp_no,
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.acService
      .getCuttingList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;
        if (
          that.filter.status == "AC INCOMPLETE" &&
          that.filter.groupby == "cu_no"
        ) {
          let orderList1 = that.orderList.filter(
            (el) => el.comp_status == "PENDING"
          );
          that.orderList = orderList1;
        }
          if (
          that.filter.groupby == "cu_no" ||
          (that.filter.status == "AC INCOMPLETE" &&
            that.filter.groupby == "wo_no")
        ) {
          that.total_mtrs = 0;
          that.total_wo = 0;
          that.total_qty = 0;

          that.orderList.forEach((el) => {
            that.total_mtrs += el.tot_mtrs_qty;
            that.total_wo += el.no_of_wo;
            that.total_qty += el.tot_pcs_qty;
          });
          that.total_mtrs =
            Math.round((that.total_mtrs + Number.EPSILON) * 100) / 100;
          that.total_wo =
            Math.round((that.total_wo + Number.EPSILON) * 100) / 100;
        }
        if(that.filter.groupby == "wo_no"){
          that.total_qty = 0;
          that.orderList.forEach((el) => {
            that.total_qty += el.tot_pcs;
          });
        }
      });
  }

  // deleteOrder(row: any): void {
  //   let that = this,
  //     params = {
  //       ac_id: row.ac_id,
  //       cu_no: row.cu_no,
  //     };
  //   swal({
  //     title: "Are you sure to delete this Cutting Details?",
  //     text: "You will not be able to recover this" + " " + row["cu_no"] + "",
  //     type: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes, delete it!",
  //     cancelButtonText: "No, keep it",
  //   }).then(
  //     function () {
  //       that.isLoadMask = that.acService
  //         .delete(params)
  //         .then(function (res: any) {
  //           that.loadingIndicator = false;
  //           that.getOrderList();
  //           let errtype = "success",
  //             errmsg = res.message;
  //           if (!res.success) {
  //             errtype = "error";
  //           }

  //           that.toasterService.pop({
  //             bodyOutputType: 1,
  //             type: errtype,
  //             title: errtype.toUpperCase(),
  //             body: errmsg,
  //           });
  //         });
  //     },
  //     function (dismiss) {}
  //   );
  // }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/jobworkorder/JobactualCutting.ts